import React from 'react'

export const Loader = () => {
	return <div className='c-loader'>Loader ...</div>
}

export default Loader
